import { Typography } from "@/components/Typography"

interface Props {
  title: string
  value?: string
}

const InfoItem = ({ title, value }: Props) => {
  return (
    <div className="flex items-center gap-4">
      <Typography
        variant="body-small"
        className="text-label-secondary w-25 text-start shrink-0"
      >
        {title}
      </Typography>
      <Typography variant="body-small">{value}</Typography>
    </div>
  )
}

export default InfoItem
